import Vue from 'vue';

const inspectionFieldKeys = [
  'commissioning_date_checked',
  'counter_number_checked',
  'counter_number_matches_photo_checked',
  'counter_number_matches_location_checked',
  'billing_module_assignment_possible_checked',
  'manufacturer_type_plausible_checked',
  'electrical_connection_value_plausible_checked',
  'storage_capacity_plausible_checked',
  'ripple_receiver',
];

const deviceKeys = [
  'wallbox',
  'heat_pump',
  'air_conditioning',
  'battery_storage',
];

const counterNumberChildFieldKeys = [
  'counter_number_matches_photo_checked',
  'counter_number_matches_location_checked',
];

function getInspectionFieldKeysForDevice(deviceKey) {
  return inspectionFieldKeys.filter((fieldKey) => {
    if (fieldKey === 'counter_number_checked') {
      return false;
    }

    if (
      fieldKey === 'storage_capacity_plausible_checked' &&
      deviceKey !== 'battery_storage'
    ) {
      return false;
    }

    return true;
  });
}

function syncDerivedInspectionFields(state, deviceKey) {
  state[`${deviceKey}_counter_number_checked`] =
    counterNumberChildFieldKeys.every(
      (fieldKey) => state[`${deviceKey}_${fieldKey}`] === true
    );
}
function createInitialInspectionState() {
  return deviceKeys.reduce((state, deviceKey) => {
    inspectionFieldKeys.forEach((fieldKey) => {
      state[`${deviceKey}_${fieldKey}`] =
        fieldKey === 'ripple_receiver' ? null : false;
    });

    return state;
  }, {});
}

export const consumptionDevicesModule = {
  state: {
    selectedConsumptionDevicesOrder: {},
    supply_installation_number_provided: false,
    inspectionDraftOrderId: null,
    ...createInitialInspectionState(),
  },
  mutations: {
    deleteSelectedConsumptionDevicesOrder(state) {
      state.selectedConsumptionDevicesOrder = {};
      state.inspectionDraftOrderId = null;
    },
    setSelectedConsumptionDevicesOrder(state, selectedConsumptionDevicesOrder) {
      state.selectedConsumptionDevicesOrder = selectedConsumptionDevicesOrder;
    },
    updateSelectedConsumptionDevicesData(state, newValue) {
      Object.keys(newValue).forEach((changedPart) => {
        Vue.set(
          state.selectedConsumptionDevicesOrder,
          changedPart,
          newValue[changedPart]
        );
      });
    },
    updateExactParamsInSelectedConsumptionDevice(state, newValue) {
      deepUpdate(state.selectedConsumptionDevicesOrder, newValue);
    },
    updateLastChangedByInSelectedConsumptionDevice(state, last_changed_by) {
      state.selectedConsumptionDevicesOrder.last_changed_by = last_changed_by;
    },
    updateLastUpdateInSelectedConsumptionDevice(state, last_update) {
      state.selectedConsumptionDevicesOrder.last_update = last_update;
    },
    setSupplyInstallationNumberProvided(state, value) {
      state.supply_installation_number_provided = value;
    },
    setDeviceInspectionValue(state, { deviceKey, fieldKey, value }) {
      const stateKey = deviceKey + '_' + fieldKey;
      if (stateKey in state) {
        state[stateKey] = value;
      }

      if (
        fieldKey === 'counter_number_checked' ||
        counterNumberChildFieldKeys.includes(fieldKey)
      ) {
        syncDerivedInspectionFields(state, deviceKey);
      }
    },
    setSelectedDeviceTechnicalValues(state, payload) {
      const isHydrationPayload =
        payload &&
        typeof payload === 'object' &&
        Object.prototype.hasOwnProperty.call(
          payload,
          'technicalInspectionData'
        );

      const orderId = isHydrationPayload ? payload.orderId ?? null : null;
      const technicalInspectionData = isHydrationPayload
        ? payload.technicalInspectionData || {}
        : payload || {};
      const force = isHydrationPayload ? payload.force === true : true;

      if (
        !force &&
        orderId &&
        state.inspectionDraftOrderId &&
        state.inspectionDraftOrderId === orderId
      ) {
        return;
      }

      const initialState = createInitialInspectionState();
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key];
      });

      state.supply_installation_number_provided =
        technicalInspectionData.supply_installation_number_provided === true;

      Object.keys(technicalInspectionData).forEach((deviceKey) => {
        if (deviceKey === 'supply_installation_number_provided') return;
        const deviceData = technicalInspectionData[deviceKey];

        if (!deviceData) {
          return;
        }

        inspectionFieldKeys.forEach((fieldKey) => {
          const stateKey = deviceKey + '_' + fieldKey;
          if (!(stateKey in state)) {
            return;
          }

          if (fieldKey === 'ripple_receiver') {
            state[stateKey] = deviceData[fieldKey] ?? null;
            return;
          }

          state[stateKey] = deviceData[fieldKey] === true;
        });

        syncDerivedInspectionFields(state, deviceKey);
      });

      state.inspectionDraftOrderId = orderId;
    },
  },
  getters: {
    getSelectedConsumptionDevice(state) {
      return state.selectedConsumptionDevicesOrder;
    },
    getSelectedDeviceTechnicalValues(state) {
      const result = {};
      const devices =
        state.selectedConsumptionDevicesOrder?.controllable_devices || {};

      Object.keys(devices).forEach((deviceKey) => {
        if (!devices[deviceKey]) {
          return;
        }

        result[deviceKey] = getInspectionFieldKeysForDevice(deviceKey).reduce(
          (deviceResult, field) => {
            deviceResult[field] = state[`${deviceKey}_${field}`];
            return deviceResult;
          },
          {}
        );
      });

      return result;
    },
  },
  actions: {},
};

function deepUpdate(target, source) {
  Object.keys(source).forEach((key) => {
    if (
      typeof source[key] === 'object' &&
      source[key] !== null &&
      !Array.isArray(source[key])
    ) {
      if (!target[key]) Vue.set(target, key, {});
      deepUpdate(target[key], source[key]);
    } else {
      Vue.set(target, key, source[key]);
    }
  });
}
